import { render, staticRenderFns } from "./EstadisticaDiagnosticosSinValidar.vue?vue&type=template&id=6b1b8313&scoped=true"
import script from "./EstadisticaDiagnosticosSinValidar.vue?vue&type=script&lang=js"
export * from "./EstadisticaDiagnosticosSinValidar.vue?vue&type=script&lang=js"
import style0 from "./EstadisticaDiagnosticosSinValidar.vue?vue&type=style&index=0&id=6b1b8313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b8313",
  null
  
)

export default component.exports